<div class="suggestion-cards" [ngClass]="gridColumnsClass">
  <div class="suggestion-card"
       *ngFor="let suggestion of suggestions; let i = index"
       (click)="onSuggestionClick(suggestion)">
    <div class="card-content">
      <div class="card-title"
           #cardTitle
           [matTooltip]="suggestion.title"
           [matTooltipPosition]="'above'"
           [matTooltipClass]="'suggestion-card-tooltip'"
           [matTooltipDisabled]="!isCardTruncated(i)">{{ suggestion.title }}</div>
    </div>
  </div>
</div>
